import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import s from './SophisticatedTooltipLink.scss';
var SophisticatedTooltipLink = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    return (React.createElement(PlainButtonOrLink, __assign({ className: c(s['root'], className) }, rest), children));
};
SophisticatedTooltipLink.displayName = 'SophisticatedTooltipLink';
export default SophisticatedTooltipLink;
//# sourceMappingURL=SophisticatedTooltipLink.js.map